var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWaze = function SvgWaze(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M288,416c114.88,0,208-85.952,208-192S402.88,32,288,32S80,117.952,80,224c0,0,15.008,96-64,96 C16,400,160,416,288,416"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M288,432C94.208,432,0,395.36,0,320c0-8.832,7.168-16,16-16c15.872,0,27.456-4.544,35.424-13.824 c18.688-21.856,12.832-63.296,12.768-63.712C64,109.312,164.48,16,288,16c123.488,0,224,93.312,224,208S411.488,432,288,432z  M34.432,334.336C49.664,377.376,136.576,400,288,400c105.888,0,192-78.976,192-176c0-97.056-86.112-176-192-176S96,126.944,96,224 l0,0c0.192,0,8.16,53.792-20.256,86.976C65.152,323.328,51.328,331.168,34.432,334.336z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#37474F"
    },
    cx: 352,
    cy: 432,
    r: 64
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#37474F"
    },
    cx: 160,
    cy: 432,
    r: 64
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M224.64,192c-8.832,0-16.16-7.168-16.16-16s7.008-16,15.84-16h0.32c8.832,0,16,7.168,16,16 S233.472,192,224.64,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M352.64,192c-8.8,0-16.16-7.168-16.16-16s7.008-16,15.84-16h0.32c8.832,0,16,7.168,16,16 S361.472,192,352.64,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M288,336c-46.144,0-85.472-31.424-95.616-76.48c-1.92-8.64,3.488-17.184,12.096-19.136 c8.64-1.856,17.184,3.456,19.136,12.096C230.432,282.816,256.928,304,288,304c31.104,0,57.568-21.184,64.384-51.52 c1.984-8.608,10.432-14.016,19.136-12.096c8.64,1.952,14.048,10.496,12.128,19.136C373.504,304.544,334.176,336,288,336z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaze, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waze.516d1127.svg";
export { ForwardRef as ReactComponent };